// extracted by mini-css-extract-plugin
export var closeButton = "_l4-2";
export var closeButtonIcon = "_l4-3";
export var lightboxContent = "_l4-1";
export var lightboxOverlay = "_l4-0";